import { debounce } from '../utils/utils.js'

class Promobar {
  constructor(element) {
    this.element = element;
    this.init();
  }

  getElement() {
    return this.element;
  }

  getMobileMenu() {
    return document.querySelector('.js-mobileMenu');
  }

  getActive(){
    let element = this.getElement();
    return element.classList.contains('active');
  }

  getIndex() {
    let element = this.getElement();
    return element.dataset.index;
  }

  getPromobar() {
    let element = this.getElement();
    return element.querySelector('.js-promo');
  }

  getHeader(){
    let element = this.getElement();
    return element.querySelector('.js-headerMain');
  }

  getClose(){
    let element = this.getElement();
    return element.querySelector('.js-closePromo');
  }

  getHeight(){
    let headerEl = this.getHeader();
    return headerEl.offsetHeight;
  }

  getBody(){
    return document.querySelector('body');
  }

  getCookie(cookieKey) {
    let cookieName = `${cookieKey}=`;
    let cookieArray = document.cookie.split(";");

    for (let cookie of cookieArray) {
      while (cookie.charAt(0) == " ") {
        cookie = cookie.substring(1, cookie.length);
      }

      if (cookie.indexOf(cookieName) == 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
  }

  setCookie(cookieKey, cookieValue, expirationDays) {
    let expiryDate = "";

    if (expirationDays) {
      const date = new Date();
      date.setTime(
        `${date.getTime()}${expirationDays || 30 * 24 * 60 * 60 * 1000}`
      );
      expiryDate = `; expiryDate=" ${date.toUTCString()}`;
    }

    document.cookie = `${cookieKey}=${cookieValue || ""}${expiryDate}; path=/`;
  }

  setClose() {
    let closeEl = this.getClose();
    let promobarEl = this.getPromobar();

    closeEl.addEventListener("click", () => {
      promobarEl.classList.add("hide");
      this.setCookie("hidePromo", 1, 7);
      this.setHeight();
    });
  }

  setHeight() {
    let bodyEl = this.getBody();
    let heightEl = this.getHeight();
    let indexEl = this.getIndex();
    let mobileMenuEl = this.getMobileMenu();

    indexEl === 'false' 
    ? bodyEl.style.marginTop = heightEl+'px'
    : null;

    mobileMenuEl.style.setProperty('height', `calc(100vh - ${heightEl}px)`);
  }

  setResize() {
    let bodyEl = this.getBody();

    window.addEventListener(
      "resize",
      debounce(() => {
        let headerHeight = this.getHeight();
        bodyEl.style.marginTop = `${headerHeight}px`;
      }, 500)
    );
  }

  checkCookie() {
    let cookieEl = this.getCookie("hidePromo");
    let promobarEl = this.getPromobar();
    if (cookieEl == "1") {
      promobarEl.classList.add("hide");
    } 
    else{
      this.setClose();
      this.setHeight();
      this.setResize();
    }
  }

  setEventHandlers() {
    this.checkCookie();
  }

  init() {
    this.setEventHandlers();
  }
}

const PromobarInit = {
  init() {
    const $el = document.querySelector(".js-promo");
    const $ell = document.querySelector('header');
    if ($el) {
      new Promobar($ell);
    }
  },
};

export default PromobarInit;